<app-navbar-style-two></app-navbar-style-two>

<div class="inner-banner">
  <div class="container">
    <div class="inner-title text-center">
      <h3>Terms & Conditions</h3>
      <ul>
        <li><a href="index.html">Home</a></li>
        <li><i class="bx bx-chevron-right"></i></li>
        <li>Terms & Conditions</li>
      </ul>
    </div>
  </div>

  <div class="inner-banner-shape">
    <div class="shape-one">
      <img src="assets/img/inner-banner/banner-shape1.png" alt="Images" />
    </div>
    <div class="shape-two">
      <img src="assets/img/inner-banner/banner-shape2.png" alt="Images" />
    </div>
    <div class="shape-three">
      <img src="assets/img/inner-banner/banner-shape3.png" alt="Images" />
    </div>
    <div class="inner-banner-dots">
      <img src="assets/img/shape/dots-shape.png" alt="Images" />
    </div>
  </div>
</div>

<div class="terms-conditions-area pt-50 pb-70">
  <div class="container">
    <div class="single-content">
      <h1>Terms of Use</h1>

      <p>
        These Terms and Conditions ("Terms"), including any future
        modifications, form a contract between you or your company ("you" or
        "your") and AON SYSTEMS INC ("Ring Pilot," "we," "us," or "our"),
        governing your use and our provision of the Services (as defined below).
        By using Ring Pilot's web-based interface, messaging application, dialer
        application, fax broadcasting application, social media marketing
        application, e-commerce application, data encryption, transmission,
        access, and storage systems, APIs, networks, and websites (including but
        not limited to www.ringpiolet.us) (collectively, the "Services"), you
        confirm that you have read, understood, and agreed to be bound by the
        most recent version of these Terms.
      </p>

      <p>
        You may review the current version of the Terms at any time at
        http://www.ringpiolet.us/terms/ ("Terms Page"). We may update the Terms
        without notice, effective immediately upon posting on the Terms Page.
        Continued use of the Services constitutes your acceptance of those
        changes. New features that augment or enhance the Services will also be
        subject to these Terms.
      </p>

      <h4>1. Account Terms</h4>

      <ol>
        <li>You must be 18 years or older to use the Service.</li>
        <li>
          You must provide your legal full name, a valid email address, and any
          other requested information to complete signup. Inaccurate or
          incomplete information may lead to termination of your access.
        </li>
        <li>Only one free account per person or legal entity is permitted.</li>
        <li>
          You are responsible for maintaining the confidentiality of your
          account credentials. Sharing your username and password is prohibited.
          Notify us immediately if you suspect unauthorized use.
        </li>
        <li>
          You are responsible for all content and activity under your account,
          including sub-accounts.
        </li>
        <li>
          You may not use the Services for any illegal or unauthorized purpose,
          including but not limited to violations of copyright or trademark
          laws.
        </li>
        <li>
          You are responsible for complying with all applicable local, state,
          national, and international laws.
        </li>
        <li>
          You may not use automated tools (e.g., bots, spiders) to monitor or
          copy content from the Services.
        </li>
        <li>
          You may not resell, duplicate, reproduce, or exploit any portion of
          the Service without written permission from Ring Pilot.
        </li>
        <li>
          We may modify, suspend, or discontinue the Service at any time, for
          any reason, without liability.
        </li>
        <li>
          We claim no ownership or intellectual property rights over content you
          provide.
        </li>
        <li>
          Upon account termination, all your data will be permanently deleted.
        </li>
      </ol>

      <h4>2. Services</h4>

      <p>
        You agree to use Ring Pilot Services in accordance with all applicable
        guidelines and laws. Ring Pilot is only responsible for processing and
        delivering Services to the applicable network. Final delivery of
        communication is the responsibility of the carrier. We use major telecom
        and mobile operators to transmit messages and calls. We do not guarantee
        specific delivery times. Messages undelivered within the carrier’s
        assigned lifespan may be discarded without notice. Ring Pilot is not
        liable for any financial or other losses due to non-delivery. Messages
        and broadcasts are deemed to have zero monetary value.
      </p>

      <h4>3. Usage Policy</h4>

      <p>
        You represent and warrant that recipients of your messages have opted in
        to receive such communications. You agree to:
      </p>

      <ol>
        <li>
          <p>
            Follow the Consumer Best Practices Guidelines from the Mobile
            Marketing Association.
          </p>
        </li>
        <li>
          <p>
            Immediately honor “Do Not Call” (DNC) requests by removing affected
            numbers from all campaign lists.
          </p>
        </li>
        <li>
          <p>
            Familiarize yourself and comply with all relevant laws (e.g., TCPA,
            FTC, FCC, and state regulations). Helpful resources:
          </p>
          <ul>
            <li>FTC</li>
            <li>FCC</li>
            <li>Do Not Call Registry</li>
          </ul>
        </li>
      </ol>

      <p>
        You are solely responsible for the legality and content of your
        communications.
      </p>
      <p>
        You must consult legal counsel if unsure of the compliance requirements.
      </p>

      <ol>
        <li>
          Prohibited Practices:
          <ul>
            <li>Sending unsolicited marketing messages (spam).</li>
            <li>Calling emergency or utility-related services.</li>
            <li>Using random number sequences to reach multiple lines.</li>
            <li>
              Harvesting or collecting personal information without consent.
            </li>
            <li>Misleading recipients about your identity.</li>
            <li>Transmitting content that violates IP laws.</li>
            <li>Sending viruses, malware, or harmful software.</li>
            <li>
              Attempting unauthorized access or interfering with the Services.
            </li>
            <li>Disrupting another user’s experience.</li>
            <li>Engaging in illegal or harmful conduct.</li>
          </ul>
        </li>

        <li>
          Prohibited Content Includes:
          <ol>
            <li>Pornographic or sexual content.</li>
            <li>Harassing or abusive language.</li>
            <li>Firearms (including fireworks).</li>
            <li>Alcohol, tobacco, or illegal drugs.</li>
            <li>
              Loans, loan forgiveness, debt relief, credit repair, or tax
              content.
            </li>
            <li>Gambling.</li>
            <li>Investment solicitations.</li>
            <li>Unsolicited real estate offers (e.g., "We Buy Homes").</li>
            <li>Multi-level marketing schemes.</li>
            <li>
              Excessive use of one-time passcodes on behalf of other services.
            </li>
          </ol>
        </li>
      </ol>

      <p>
        All outbound campaigns must include legal contact information in the
        initial greeting message. Ring Pilot assumes no responsibility for the
        content or accuracy of your communications. You are responsible for your
        own sound files, text messages, and fax messages. Misuse of the Services
        is your sole liability. The opinions and views expressed in your content
        do not reflect those of Ring Pilot.
      </p>

      <h4>4. Payment Terms</h4>

      <ol>
        <li>
          A valid credit card is required for paid accounts unless otherwise
          specified. Free accounts are not required to provide a credit card
          number.
        </li>
        <li>
          The Free Account offers new, registered users/entities a no-cost trial
          of the Service. Ring Pilot may restrict features in the free account
          and reserves the right to change its terms, duration, or cost at any
          time. To access additional features beyond the free account, users
          must subscribe to a paid plan.
        </li>
        <li>
          Services are billed in advance on a monthly or yearly basis and are
          non-refundable. No refunds or credits will be issued for:
        </li>
        <ul>
          <li>Partial months of service</li>
          <li>Upgrade/downgrade changes</li>
          <li>Unused months with an open accoun</li>
          <li>Non-payment may lead to account suspension or termination.</li>
        </ul>
        <li>
          All fees exclude applicable taxes, levies, and duties. The user is
          responsible for any such charges.
        </li>
        <li>
          Ring Pilot accepts no responsibility for content loss resulting from
          service downgrades.
        </li>
        <li>
          Ring Pilot reserves the right to modify service fees with 30 days’
          notice, which may be posted on the website
          <a href="https://ringpiolet.us">(https://ringpiolet.us)</a> or within
          the Service.
        </li>
        <li>
          Purchased credits expire at the end of the corresponding quarter or
          one year from the purchase date unless otherwise stated in your plan.
          Unused credits are non-refundable and will be forfeited upon
          expiration.
        </li>
      </ol>

      <h4>5. Cancellation and Termination</h4>

      <ol>
        <li>You are solely responsible for properly canceling your account.</li>
        <li>No cancellation fees apply.</li>
        <li>
          All content will be deleted immediately upon cancellation and cannot
          be recovered.
        </li>
        <li>
          No refunds will be issued if the Service is canceled before the end of
          your paid billing period. Future billing will cease.
        </li>
        <li>
          Ring Pilot reserves the right to terminate services, suspend accounts,
          or terminate this agreement for any reason, at any time. In such
          cases, access to your account and its contents will be disabled.
        </li>
        <li>
          Ring Pilot reserves the right to refuse service to anyone at any time
          for any reason.
        </li>
        <li>
          Accounts inactive for more than 90 days (no login activity) will be
          permanently removed from our servers.
        </li>
      </ol>

      <h4>6. Intellectual Property Rights</h4>

      <ol>
        <li>
          Ring Pilot owns all rights to the code, databases, visual design, and
          layout of the Service.
        </li>
        <li>
          Ring Pilot does not claim ownership over content or materials uploaded
          by users. Your content remains yours.
        </li>
        <li>
          You may not use automated or manual tools (e.g., robots, spiders) to
          monitor or copy content from the Service.
        </li>
        <li>
          You may not resell, duplicate, reproduce, or exploit any part of the
          Service without written permission from Ring Pilot.
        </li>
        <li>
          You may not duplicate or reuse any portion of the visual design or
          layout without written permission from Ring Pilot.
        </li>
      </ol>

      <h4>7. Warranties and Limitations of Liability</h4>

      <p>Ring Pilot does not guarantee that:</p>
      <ul>
        <li>The Service will meet your requirements or expectations.</li>
        <li>
          The Service will be uninterrupted, timely, secure, or error-free.
        </li>
        <li>All calculations or results provided are accurate.</li>
        <li>Any bugs or errors will be fixed.</li>
      </ul>

      <p>Ring Pilot is not liable for:</p>
      <ul>
        <li>
          Direct, indirect, incidental, special, or consequential damages.
        </li>
        <li>
          Loss of profits, goodwill, data, or other intangible losses—even if
          Ring Pilot has been advised of such damages.
        </li>
      </ul>

      <p>Additional clauses:</p>
      <ol>
        <li>
          Not all features or services will be available in every jurisdiction.
          Ring Pilot may modify or discontinue features without notice.
        </li>
        <li>Ring Pilot may remove or refuse content at its discretion.</li>
        <li>
          Abusive behavior (verbal or written) toward Ring Pilot personnel will
          result in immediate termination of the account.
        </li>
        <li>
          Ring Pilot may offer services to competitors and does not guarantee
          exclusivity.
        </li>
        <li>
          In case of disputes over account ownership, Ring Pilot may request
          proof (e.g., business license, ID, credit card verification).
        </li>
        <li>
          Ring Pilot will determine account ownership at its sole discretion. If
          no resolution is found, the account may be suspended.
        </li>
      </ol>

      <h4>8. Limitation of Liability</h4>

      <p>
        In no event shall Ring Pilot's aggregate liability exceed the fees paid
        in the immediately preceding month of the claim.
      </p>
      <p>
        Some jurisdictions do not allow such exclusions or limitations, so they
        may not apply to all users.
      </p>

      <h4>9. Usage and Liability</h4>

      <p>
        You (the User, Company, or Nonprofit) are fully liable for all calls,
        faxes, and messages sent from your account.
      </p>

      <p>You agree to the following:</p>
      <ul>
        <li>If you do not accept these Terms, exit the site immediately.</li>
        <li>
          If you do not intend to use Ring Pilot responsibly, do not use the
          services.
        </li>
      </ul>

      <p>You further agree to:</p>
      <ol>
        <li>
          Indemnify and hold harmless Ring Pilot and its affiliates, officers,
          employees, and agents from any third-party claims, including:
        </li>
        <ul>
          <li>Breach of these Terms</li>
          <li>Violation of laws or third-party rights</li>
          <li>
            Disputes with customers, including refunds, fraud, and legal
            violations
          </li>
        </ul>
        <li>
          Be responsible for any breach of these Terms by your affiliates,
          agents, or subcontractors.
        </li>
        <li>
          Use the Service at your own risk; it is provided “as is” and “as
          available”.
        </li>
        <li>Acknowledge that Ring Pilot does not guarantee:</li>
        <ul>
          <li>Uninterrupted or error-free operation</li>
          <li>Accuracy or reliability of results</li>
        </ul>
        <li>
          Accept responsibility for any tax obligations related to using Ring
          Pilot.
        </li>
        <li>
          Ring Pilot reserves the right to update these Terms at any time,
          including changes that materially impact your rights, with or without
          notice. Continued use of the Services after changes implies acceptance
          of the updated Terms.
        </li>
        <li>
          Ring Pilot may modify its fees at any time with 30 days' notice
          provided via email or through the admin console. Ring Pilot is not
          liable for any modifications, price changes, or discontinuation of
          services.
        </li>
      </ol>

      <h4>10. Responsible Use</h4>

      <p>By using Ring Pilot services, the Customer agrees to the following:</p>

      <ol>
        <li>
          <strong>Legal Compliance</strong>
          <p>
            The Customer agrees to familiarize themselves and comply with all
            applicable International, Federal, State, and Local laws governing
            the use of dialing, messaging, and faxing services.
          </p>
        </li>
        <li>
          <strong>Do Not Call (DNC) Compliance</strong>
          <p>
            The Customer agrees to immediately add any individual requesting DNC
            status to the Customer’s internal DNC list.
          </p>
        </li>
        <li>
          <strong>Outbound Campaign Contact Disclosure</strong>
          <p>
            The Customer agrees to include valid legal contact information
            within the initial greeting of all outbound campaigns.
          </p>
        </li>
        <li>
          <strong>Use of Audio Files</strong>
          <p>
            The Customer is responsible for providing all sound/audio files used
            in outbound campaigns.
          </p>
        </li>
        <li>
          <strong>Data Responsibility</strong>
          <p>
            The Customer agrees to supply all data used in campaigns and assumes
            full responsibility for ensuring campaigns are conducted courteously
            and legally toward recipients.
          </p>
        </li>
        <li>
          <strong>Responsible Scheduling</strong>
          <p>
            The Customer agrees to schedule all campaigns responsibly and
            ethically.
          </p>
        </li>
        <li>
          <strong>Prohibited Numbers</strong>
          <p>
            The Customer agrees not to send calls to emergency or life-line
            services such as:
          </p>
          <ul>
            <li>911</li>
            <li>Hospitals</li>
            <li>Police</li>
            <li>Fire departments</li>
            <li>Utility-related numbers</li>
          </ul>
        </li>
        <li>
          <strong>Consent-Based Broadcasting</strong>
          <p>
            The Customer agrees not to send outbound sales broadcasts to
            recipients who have not provided prior consent to receive such
            communications.
          </p>
        </li>
        <li>
          <strong>DNC/Opt-Out Features</strong>
          <p>
            The Customer agrees to utilize the DNC and opt-out features made
            available through the Ring Pilot system.
          </p>
        </li>
        <li>
          <strong>Legal Consultation</strong>
          <p>
            If unsure about the legality of dialing, messaging, or faxing any
            data, the Customer agrees to consult with a licensed attorney before
            proceeding.
          </p>
        </li>
      </ol>

      <h4>11. Legal and Dispute Resolution</h4>

      <p>
        <strong>Company Information:</strong><br />
        AON SYSTEMS INC., a USA corporation<br />
        Address: 9406 Michael Ct, Morton Grove, IL 60053
      </p>

      <p>
        <strong>Governing Law:</strong><br />
        These Terms shall be governed and construed in accordance with the laws
        of the Province of Ontario, excluding its conflict of law principles.
      </p>

      <p><strong>Dispute Resolution:</strong></p>
      <ul>
        <li>
          Any dispute arising under these Terms shall be resolved via binding
          arbitration conducted in the Province of Ontario, under the rules of
          the American Arbitration Association.
        </li>
        <li>
          Arbitration shall be conducted on an individual basis only, not as a
          class action.
        </li>
        <li>
          Claims for non-payment by Ring Pilot are exempt from arbitration.
        </li>
        <li>
          Either party may seek equitable or injunctive relief in a court of
          competent jurisdiction in Ontario for any breach causing irreparable
          harm.
        </li>
      </ul>

      <h4>General Conditions</h4>

      <ol>
        <li>
          <strong>Entire Agreement</strong>
          <p>
            These Terms of Service, along with all referenced documents,
            constitute the entire agreement between the Customer and Ring Pilot,
            superseding any prior agreements.
          </p>
        </li>
        <li>
          <strong>No Waiver</strong>
          <p>
            Failure by Ring Pilot to enforce any provision shall not be deemed a
            waiver of such rights.
          </p>
        </li>
        <li>
          <strong>Severability</strong>
          <p>
            If any provision is deemed illegal or unenforceable, it shall be
            modified to best achieve its intent within the bounds of the law.
            Remaining provisions remain in full force.
          </p>
        </li>
        <li>
          <strong>Third-Party Rights</strong>
          <p>
            Except as otherwise stated, no third party shall have the right to
            enforce any term of this agreement, unless as a permitted assignee
            or transferee.
          </p>
        </li>
        <li>
          <strong>Governing Law</strong>
          <p>
            These Terms shall be governed by the laws of the Province of
            Ontario, without regard to conflicts of law principles.
          </p>
        </li>
        <li>
          <strong>Binding Effect</strong>
          <p>
            These Terms shall bind and benefit both parties and their respective
            heirs, successors, and permitted assigns.
          </p>
          <ul>
            <li>Ring Pilot may assign its rights without Customer consent.</li>
            <li>
              The Customer may not assign these Terms without Ring Pilot’s prior
              written consent.
            </li>
          </ul>
        </li>
        <li>
          <strong>Termination</strong>
          <p>
            Upon termination of the agreement, all rights and obligations cease,
            except:
          </p>
          <ul>
            <li>
              The Customer remains responsible for obligations and liabilities
              incurred before termination.
            </li>
          </ul>
        </li>
      </ol>

      <h4>Ecommerce Terms of Service – Ring Pilot</h4>

      <h4>1. Account Activation</h4>
      <ol>
        <li>
          <h4>Store Owner</h4>
          <p>
            The person signing up for the Service is considered the Store Owner,
            the contracting party for these Terms of Service.
          </p>
          <p>
            The Store Owner is authorized to use the corresponding account and
            is responsible for ensuring that their legal name or business name
            is clearly visible on the Store’s website.
          </p>
        </li>
      </ol>

      <h4>2. Payment Accounts</h4>
      <ol>
        <li>
          <h4>PayPal Express Checkout & Ring Pilot Payments</h4>
          <p>
            Upon sign-up, Ring Pilot will create a PayPal Express Checkout
            account using your Primary Email Address. Depending on your
            location, a Ring Pilot Payments account may also be created.
          </p>
          <p>
            PayPal Express Checkout and Ring Pilot Payments will be the default
            payment gateways.
          </p>
          <p>
            You are responsible for activating, maintaining, or deactivating
            these accounts.
          </p>
          <p>
            Note: PayPal Express Checkout is a Third Party Service under Section
            9.7.1.
          </p>
        </li>
        <li>
          <h4>Shop Pay</h4>
          <p>
            If enrolled in Ring Pilot Payments, Shop Pay will be automatically
            enabled on your checkout page.
          </p>
          <p>
            You can manage or remove Shop Pay in your Ring Pilot admin console.
          </p>
          <p>
            By using Shop Pay, you accept the own Pay Merchant Terms of Service,
            which may be updated by Ring Pilot from time to time.
          </p>
        </li>
        <li>
          <h4>Skype Pay</h4>
          <p>
            Upon sign-up, Ring Pilot will create a Skype Pay account using your
            business name and URLs.
          </p>
          <p>
            Activation may be automatic or manual depending on your location.
          </p>
          <p>Skype Pay is a Third Party Service under Section 9.7.1.</p>
          <p>
            By using Skype Pay, you agree to the Skype Pay Platform Web Merchant
            Terms and Conditions, which may be amended by Skype. Continued use
            implies acceptance of any updates.
          </p>
        </li>
      </ol>

      <h4>3. Payment of Fees and Taxes</h4>
      <ol>
        <li>
          <h4>Types of Fees</h4>
          <ul>
            <li>Subscription Fees – charged for Online and/or POS Services.</li>
            <li>
              Transaction Fees – charged for sales made through your Store using
              third-party gateways.
            </li>
            <li>
              Additional Fees – includes charges for services like Ring Pilot
              Payments, POS equipment, shipping, apps, domains, Experts
              Marketplace, and other Third Party Services.
            </li>
          </ul>
          <p>Collectively referred to as “Fees.”</p>
        </li>
        <li>
          <h4>Billing & Payment</h4>
          <p>You must keep a valid Authorized Payment Method on file.</p>
          <p>
            Fees will be billed in 30-day intervals (Billing Date) and invoices
            sent to your Primary Email and available in your admin console.
          </p>
          <p>
            If Ring Pilot is unable to process payment after 28 days, your
            account may be suspended.
          </p>
          <p>If unpaid for 60 days, Ring Pilot may terminate your account.</p>
        </li>
        <li>
          <h4>Taxes</h4>
          <p>All Fees are exclusive of applicable taxes.</p>
          <p>
            You are responsible for all applicable taxes unless you provide
            proper tax exemption documentation.
          </p>
          <p>
            Ring Pilot calculates taxes based on your billing address and may
            collect them accordingly.
          </p>
        </li>
        <li>
          <h4>No Refund Policy</h4>
          <p>Ring Pilot does not provide refunds under any circumstances.</p>
        </li>
      </ol>

      <h4>4. Intellectual Property and Your Materials</h4>
      <ol>
        <li>
          <h4>Your Materials</h4>
          <p>
            You retain ownership of content (“Materials”) provided to Ring
            Pilot, but you grant a non-exclusive, transferable, sub-licensable,
            royalty-free license to use them globally for operating and
            promoting the services.
          </p>
          <p>
            You must have the rights to grant this license and waive any moral
            rights in the Materials.
          </p>
          <p>
            Deleting your account does not revoke rights granted to Ring Pilot
            for obligations arising before termination.
          </p>
        </li>
        <li>
          <h4>Your Trademarks</h4>
          <p>
            You grant Ring Pilot a non-exclusive, transferable, sub-licensable,
            royalty-free license to use your Store’s trademarks for operating
            and promoting services.
          </p>
          <p>
            This license survives termination only for fulfilling existing
            obligations.
          </p>
        </li>
        <li>
          <h4>Ring Pilot Intellectual Property</h4>
          <p>
            You may not use, register, or mimic Ring Pilot’s trademarks,
            including “Ring Pilot,” “Shop,” “Shop Pay,” or related logos, unless
            expressly authorized.
          </p>
          <p>
            You may not use confusingly similar names, domains, or keywords.
          </p>
        </li>
        <li>
          <h4>Patents</h4>
          <p>
            These Terms do not grant you any right to use or implement Ring
            Pilot’s patents.
          </p>
        </li>
      </ol>

      <h4>5. Your Responsibilities</h4>
      <p>
        You must provide public-facing contact info, refund policies, and order
        fulfillment timelines.
      </p>
      <p>
        The Services are not a marketplace; contracts are directly between you
        and your customers.
      </p>
      <p>You are responsible for:</p>
      <ul>
        <li>All transactions</li>
        <li>Customer service</li>
        <li>Order fulfillment</li>
        <li>Refunds and returns</li>
        <li>Legal and regulatory compliance</li>
        <li>Fraud prevention</li>
      </ul>

      <h4>6. Confidentiality</h4>
      <ol>
        <li>
          <h4>Definition of Confidential Information</h4>
          <p>
            “Confidential Information” refers to any non-public information
            disclosed by one party to the other, including but not limited to:
          </p>
          <ul>
            <li>Business strategies and plans</li>
            <li>Technical processes, designs, and formulas</li>
            <li>Software and code</li>
            <li>Customer and prospective customer information</li>
            <li>Sales, pricing, and cost information</li>
            <li>Product designs and specifications</li>
            <li>Marketing data and unpublished financial data</li>
            <li>Other proprietary or confidential data</li>
          </ul>
          <p>
            Ring Pilot’s Confidential Information also includes any non-public
            service details you receive.
          </p>
        </li>
        <li>
          <h4>Use and Protection of Confidential Information</h4>
          <p>Each party agrees to:</p>
          <ul>
            <li>
              Use Confidential Information only to perform obligations under
              these Terms.
            </li>
            <li>
              Protect Confidential Information with reasonable precautions.
            </li>
          </ul>
          <p>Disclosure is allowed only to:</p>
          <ul>
            <li>Authorized employees, agents, and subcontractors</li>
            <li>
              When legally required, with prompt notice and efforts for
              confidentiality
            </li>
          </ul>
        </li>
        <li>
          <h4>Exclusions</h4>
          <p>Obligations do not apply to information that:</p>
          <ul>
            <li>Was publicly known at disclosure</li>
            <li>Was already known without restrictions</li>
            <li>Was independently developed</li>
            <li>Was obtained lawfully from a third party</li>
          </ul>
        </li>
      </ol>

      <h4>Section A: Terms and Liability</h4>
      <ol>
        <li>
          <h4>Limitation of Liability</h4>
          <p>Ring Pilot is not liable for failures caused by:</p>
          <ul>
            <li>Acts of God</li>
            <li>Disasters</li>
            <li>Wars or terrorism</li>
            <li>Labor issues</li>
            <li>Government actions</li>
            <li>Delays in services</li>
          </ul>
        </li>
        <li>
          <h4>Exclusion of Damages</h4>
          <p>
            Ring Pilot is not liable for indirect, special, incidental, or
            consequential damages, including lost profits.
          </p>
        </li>
        <li>
          <h4>Indemnification</h4>
          <p>You agree to indemnify Ring Pilot from all claims related to:</p>
          <ul>
            <li>Libel, slander, privacy invasion</li>
            <li>Copyright issues</li>
            <li>Other intentional actions or omissions</li>
          </ul>
        </li>
        <li>
          <h4>Disclaimer of Warranties</h4>
          <p>
            No express or implied warranties, including merchantability or
            fitness for a particular purpose.
          </p>
        </li>
        <li>
          <h4>Third Party Liability</h4>
          <p>
            Ring Pilot is not responsible for third-party services or equipment,
            or customer-owned systems.
          </p>
        </li>
        <li>
          <h4>Law Enforcement Disclosure</h4>
          <p>
            Ring Pilot may disclose IP or personal info to law enforcement when
            legally required.
          </p>
        </li>
        <li>
          <h4>Compliance with Do-Not-Call Regulations</h4>
          <p>
            You are responsible for complying with Federal and State DNC
            regulations.
          </p>
        </li>
      </ol>

      <h4>Section B: Responsible Use of Service</h4>
      <p>
        As a subscriber, you are responsible for content, targets, and execution
        of your campaigns.
      </p>

      <h4>Subscriber Agreement</h4>
      <ul>
        <li>Understand applicable laws</li>
        <li>Ensure consent for contacts</li>
        <li>Keep error rates below 10%</li>
        <li>Maintain opt-out rates below 1%</li>
        <li>Respect calling time restrictions</li>
        <li>Honor all unsubscribe/DNC requests</li>
        <li>Provide clear caller ID</li>
        <li>Avoid calling emergency lines</li>
        <li>Avoid unsolicited charges</li>
        <li>Get consent for pre-recorded sales messages</li>
        <li>Review and accept Ring Pilot Terms of Service</li>
      </ul>

      <h4>Compliance Disclaimer</h4>
      <p>
        Federal and State laws, including TCPA, govern telemarketing. Exemptions
        include:
      </p>
      <ul>
        <li>Unambiguous written consent</li>
        <li>Non-profit organization calls</li>
        <li>Business-to-business calls</li>
      </ul>
      <p>
        Ring Pilot is not offering legal advice. You are responsible for legal
        compliance.
      </p>
    </div>
    <div class="single-content"></div>
  </div>
</div>

<div class="brand-logo-area pt-100">
  <div class="container-fluid">
    <div class="container-max">
      <div class="brand-logo-slider owl-carousel owl-theme">
        <div class="brand-logo-item1">
          <img src="assets/img/Legal/termsconditions.png" alt="Images" />
        </div>

        <div class="brand-logo-item1">
          <img src="assets/img/Legal/termsconditions(2).png" alt="Images" />
        </div>

        <div class="brand-logo-item1">
          <img src="assets/img/Legal/termsconditions(3).png" alt="Images" />
        </div>

        <div class="brand-logo-item1">
          <img src="assets/img/Legal/termsconditions(4).png" alt="Images" />
        </div>

        <div class="brand-logo-item1">
          <img src="assets/img/Legal/termsconditions(5).png" alt="Images" />
        </div>

        <div class="brand-logo-item1">
          <img src="assets/img/Legal/termsconditions(6).png" alt="Images" />
        </div>
      </div>
    </div>
  </div>
</div>

<app-footer-style-two></app-footer-style-two>
